export const DEMO_STORE_PROD_ALIAS_ID = 'store-EfH8xlMH5Cqhvu01VJD9MqwfWlmr';
